    function initMCSSlider() {
    const sliderEl = document.querySelector('.M-mcs-Swiper');
    if (!sliderEl) return;
    if (sliderEl.swiper) {
        sliderEl.swiper.destroy(true, true);
    }
    sliderEl.classList.remove('preview');
    const swiper = new Swiper('.M-mcs-Swiper', {
        speed: 300,
        loop: true,
        centeredSlides: true,

        navigation: {
        nextEl: '.m-mcs-next',
        prevEl: '.m-mcs-prev',
        },

        pagination: {
        el: '.swiper-pagination',
        clickable: true,
        },

        breakpoints: {
        320: {
            slidesPerView: 1.3,
            spaceBetween: 15,
        },

        750: {
            slidesPerView: 3,
            spaceBetween: 20,
        },

        950: {
            slidesPerView: 5.5,
            spaceBetween: 20,
        }
        }
    });
    function resetAllVideos() {
        const videos = sliderEl.querySelectorAll('.m-mcs-video');
        videos.forEach(function (video) {
            video.pause();
            video.currentTime = 0;
            const playBtn = video.parentElement.querySelector('.m-mcs-play-button');
            if (playBtn) {
            playBtn.classList.remove('is-hidden');
            }
        });
    }
    const playButtons = sliderEl.querySelectorAll('.m-mcs-play-button');
    playButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const media = btn.closest('.m-mcs-card-media');
        const video = media ? media.querySelector('.m-mcs-video') : null;

        if (!video) return;
        resetAllVideos();

        video.play();
        btn.classList.add('is-hidden');
        if (swiper.autoplay && swiper.autoplay.running) {
            swiper.autoplay.stop();
        }
        });
    });
    swiper.on('slideChange', function () {
        resetAllVideos();
    });
    }
    document.addEventListener('DOMContentLoaded', initMCSSlider);
    if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initMCSSlider);
    document.addEventListener('shopify:section:unload', function () {
        const sliderEl = document.querySelector('.M-mcs-Swiper');

        if (sliderEl && sliderEl.swiper) {
        sliderEl.swiper.destroy(true, true);
        }
    });
    } 
document.addEventListener("DOMContentLoaded", function() {
  var descElements = document.getElementsByClassName("u-u-u-accordion-item-desc");
  for (var j = 0; j < descElements.length; j++) {
    descElements[j].style.maxHeight = descElements[j].scrollHeight + "px";
  }
  var coll = document.getElementsByClassName("u-accordion-item-title");
  for (var i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      var desc = content.querySelector(".u-u-u-accordion-item-desc");
      if (content.style.maxHeight) {
        content.style.maxHeight = null; 
      } else {
        content.style.maxHeight = content.scrollHeight + "px"; 
      }
    });
  }
});


$('.M-trustpilot-slider').slick({
   infinite: true,
   slidesToShow: 2,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 3000,
     prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
  responsive: [
   {
      breakpoint: 900,
      settings: {
        arrows: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
   },
   {
      breakpoint: 600,
      settings: {
        arrows: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
   }
  ]
  });